import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=4008adc3&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=4008adc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008adc3",
  null
  
)

export default component.exports